module.exports = __webpack_public_path__ + "static/projects_6_1280-f2bd9e53bdd4b0477ce9e9226bdeafe2.png";